import * as THREE from 'three'
import Island from '../Components/Island'
// import Quilt from './quilt'
// import Perforation from './perforation'
// import Swatch from './swatch'
// import quiltType from 'components/Designer/MaterialEditor/Quilt/quiltType'
// import Stage from 'components/Designer/Stage'

export default class Material extends THREE.MeshStandardMaterial {
  private _island: Island
  constructor({
    island,
    ...params
  }: {
    island: Island
    roughness?: number
    metalness?: number
    normalScale?: any
    normalMap?: any
  }) {
    const data = island.swatchI.matData
    super({
      side: THREE.DoubleSide,
      vertexColors: true,
      vertexTangents: true,
      ...data,
      ...params,
    })
    this._island = island
    this.needsUpdate = true
  }
}
